import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import { Button } from "../../common/Button/Button";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import logo from "./../../assets/logo.png";

export default function DePrenuerListingDetailsModal(props) {
    return (
        <Modal
        isOpen={props.isOpen}
        onRequestClose={props.toggleModal}
        ariaHideApp={false}
    >
        <ModalContent className="ESP-deprenuer-modal">
            {props.isLoadingReports && <Spinner className="center" />}
            <div className="p-2 modal-header-bar">
                <span>dePrenuer Listing Details</span>
                <button
                    id="deprenuerClose"
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={props.toggleModal}
                >
                    <X style={{ pointerEvents: "none" }} color="white" />
                </button>
            </div>
            <div
                className={`modal-body ${props.isDisabled} ${props.isLoadingReports && "set-opacity"}`}
            >
                <div className='form-group'>
                    <div>
                        {props.selectedServiceRequestBusinessDetails.sImageUrl||
                        props.selectedServiceRequestBusinessDetails.sBusinessDescription?
                        (
                            <>
                                <div style={{textAlign:"center"}}>
                                    <div className="image-cropper">
                                        <img
                                            alt={"Icon"}
                                            src={props.selectedServiceRequestBusinessDetails.sImageUrl||""}
                                            className="cursor-pointer"
                                            style={{height:"70px"}}
                                        />
                                    </div>
                                </div>
                               
                                {/*<div className="image-cropper">
                                    <img
                                        alt={"Icon"}
                                        src={props.selectedServiceRequestBusinessDetails.sImageUrl||""}
                                        className="cursor-pointer"
                                        style={{height:"70px"}}
                                    />
                                </div>*/}
                                <div style={{clear:"both"}}></div>
                                <div  style={{marginTop:"10px"},{textAlign:"center"}}>
                                    {props.selectedServiceRequestBusinessDetails.sFirstName} {props.selectedServiceRequestBusinessDetails.sLastName}
                                </div>
                                <div style={{clear:"both"}}></div>

                                <div className="row">
                                    <div className="col-6">
                                        <div  style={{marginTop:"10px"},{textAlign:"end"}}>
                                            Business Name:
                                        </div>
                                    </div>
                                    <div className="col-6" style={{paddingLeft:"0px"}}>
                                        <div  style={{marginTop:"10px"},{textAlign:"start"}}>
                                            {props.selectedServiceRequestBusinessDetails.sBusinessName}
                                        </div>
                                    </div>

                                    <div style={{clear:"both"}}></div>
                                    <div className="col-6">
                                        <div  style={{marginTop:"10px"},{textAlign:"end"}}>
                                        Business Sector:
                                        </div>
                                    </div>
                                    <div className="col-6" style={{paddingLeft:"0px"}}>
                                        <div  style={{marginTop:"10px"},{textAlign:"start"}}>
                                            {props.selectedServiceRequestBusinessDetails.sBusinessSector}
                                        </div>
                                    </div>

                                    <div style={{clear:"both"}}></div>
                                    <div className="col-6">
                                        <div  style={{marginTop:"10px"},{textAlign:"end"}}>
                                        Pin Code:
                                        </div>
                                    </div>
                                    <div className="col-6" style={{paddingLeft:"0px"}}>
                                        <div  style={{marginTop:"10px"},{textAlign:"start"}}>
                                            {props.selectedServiceRequestBusinessDetails.pincode}
                                        </div>
                                    </div>
                                </div>                                
                            </>
                        ):("No records available")}
                        
                    </div>
                    <div style={{clear:"both"}}></div>
                </div>
            </div>
        </ModalContent>
    </Modal >
    );
  }
